// @ts-nocheck
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
var parse = require('json-parse-safe')

import { Subject } from 'rxjs'
import VueMask from 'v-mask'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'

export const eventHub = new Vue()

import './plugins/axios'
import './plugins/vuetify-dialog'
import './plugins/codes'
import './plugins/moment'
import './plugins/currency'
import './plugins/currency-field'
import './plugins/types'
import './plugins/functions'
import './plugins/tooltip'
import './plugins/validation'
import './plugins/permissions'
import '@/assets/scss/main.scss'
import VueHtmlToPaper from 'vue-html-to-paper';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import 'vuetify/dist/vuetify.min.css'
import './common/filters/defaultDate.filter';
import Keycloak from 'keycloak-js';
import * as jwt from "jwt-decode";
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(TiptapVuetifyPlugin, { vuetify, iconsGroup: 'mdi' })
Vue.use(VueHtmlToPaper);
Vue.config.productionTip = false

Vue.filter('enum', (value, data, valueProperty, textProperty) => {
   if (!data || !Array.isArray(data)) return value
  if (!valueProperty) valueProperty = 'id'
  if (!textProperty) textProperty = 'name'
  let item = data.find(item => item[valueProperty] === value)
  return item ? item[textProperty] : value
})

let initOptions = {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
  onLoad: 'login-required',
}

let keycloak = Keycloak(initOptions);
Vue.prototype.$keycloak = keycloak

function initKeycloak() {
  keycloak.init({ onLoad: 'login-required' }).then((x) => {
    console.log('result success login ', x);

    setInterval(() => {
      keycloak.updateToken(5).then((success) => { 
        if(success) {
            localStorage.setItem('token', JSON.stringify(keycloak.token));
        }
      });
    }, 20000)

    if (!x) { window.location.reload(); }

    if (keycloak.token && keycloak.idToken) {
      // DECODE DO TOKEN
      var dataUser = jwt(keycloak.token);

      localStorage.setItem('token', JSON.stringify(keycloak.token));
      localStorage.setItem('refresh_token', JSON.stringify(keycloak.refreshToken));
      localStorage.setItem('user', JSON.stringify(dataUser));

      mountAppVue();
      
      // Se estiver na raiz, vai para home
      if(router.currentRoute.path === '/') {
        router.push("/home");
      }
    }

  }).catch((err) => {
    console.log('error login ', err)
  })
}

initKeycloak();

keycloak.onAuthRefreshError = () => { initKeycloak(); }
keycloak.onTokenExpired = () => {
  keycloak.updateToken(1).then(() => {
    localStorage.setItem('token', JSON.stringify(keycloak.token));
    localStorage.setItem('refresh_token', JSON.stringify(keycloak.refreshToken));
  }).catch((err) => console.log('error updated token ', err));
}

Vue.use(VueMask)
Vue.use(VueClipboard)

function mountAppVue() {
  new Vue({
    router,
    vuetify,
    render: h => h(App),
    data: {
      title: '-',
      user: {},
      actions: {
        suggest: { visible: false, disable: false, loading: false, event: new Subject() },
        download: { visible: false, disable: false, loading: false, event: new Subject() },
        publish: { visible: false, disable: false, loading: false, event: new Subject() },
        history: { visible: false, disable: false, loading: false, event: new Subject() },
        import: { visible: false, disable: false, loading: false, event: new Subject() },
        upload: { visible: false, disable: false, loading: false, event: new Subject() },
        address: { visible: false, disable: false, loading: false, event: new Subject() },
        sync: { visible: false, disable: false, loading: false, event: new Subject() },
        productivity: { visible: false, disable: false, loading: false, event: new Subject() },
        create: { visible: false, disable: false, loading: false, event: new Subject() },
        remove: { visible: false, disable: false, loading: false, event: new Subject() },
        edit: { visible: false, disable: false, loading: false, event: new Subject() },
        editnew: { visible: false, disable: false, loading: false, event: new Subject() },
        save: { visible: false, disable: false, loading: false, event: new Subject() },
        group: { visible: false, disable: false, loading: false, event: new Subject() },
        add: { visible: false, disable: false, loading: false, event: new Subject() },
        filter: { visible: false, disable: false, loading: false, event: new Subject() },
        store: { visible: false, disable: false, loading: false, event: new Subject() },
        file: { visible: false, disable: false, loading: false, event: new Subject() }
      }
    },
    methods: {
      show: function (action) {
        for (var key in this.actions) {
          this.actions[key].visible = !!action[key];
          if (this.actions[key].visible) {
            this.actions[key].disable = false;
            this.actions[key].loading = false;
            this.actions[key].event = new Subject();
          }
        }
      }
    },
    created: function () {
      const storageUser = parse(localStorage.getItem('user'));
      this.user = storageUser.value || {};
    }
  }).$mount('#app')
}